export default function IntroRoboticFamily() {
    return (
        <div className="flex flex-col w-full items-center justify-center py-[3rem] xl:py-[5rem]">
            <div className="flex flex-col xl:flex-row justify-center items-center w-[80%] xl:w-[70%] h-full gap-y-[2rem] xl:gap-y-[0rem]">

                <div className="flex flex-col w-full xl:w-[50%] justify-center items-center gap-y-[1.5rem]">
                    <img
                        src="/pictures/introRoboticFamily.webp"
                        alt="Takamori Robot engineering kit for education robotics"
                        className="xl:w-[70%] max-w-l h-auto"
                        loading="lazy"
                    />
                </div>

                <div className="flex flex-col w-full xl:w-[50%] gap-y-[2rem]">
                    <div className="flex flex-col gap-y-[1rem]">
                        <h2 id="mission-goal" className="text-4xl font-bold">
                            A Robotics Kit for <span className="text-[#1BD743]">Families</span>
                        </h2>
                    </div>
                    <div className="flex flex-col gap-y-[1rem] font-xl font-semibold">
                        <p>
                            One thing we noticed over the course of
                            developing H.I.R.O. that we didn’t expect was
                            that H.I.R.O.’s easy assembly and 
                            approachability made, buidling, learning,
                            and interacting with H.I.R.O. a fun activity
                            to do with loved ones.
                        </p>
                        <p>
                            Whether you are introducing your family to your
                            love of science, or want a fun thing to do with 
                            your teens. Turns out building robots is a great
                            way to do both! 
                        </p> 
                    </div>
                </div>
            </div>
        </div>
    );
}